import React, { useEffect, useState } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Dashboard() {
  const [stats, setStats] = useState({ admins:0, partidos:0, usuarios:0 });

  useEffect(() => {
    Promise.all([
      api.get('/admins'),
      api.get('/partidos'),
      api.get('/usuarios'),
    ]).then(([a, p, u]) => {
      setStats({ admins: a.data.length, partidos: p.data.length, usuarios: u.data.length });
    }).catch(() => {});
  }, []);

  const cards = [
    { label:'Administradores', value: stats.admins, icon:'🛡️', color:'#EEEDFE', tc:'#3C3489' },
    { label:'Partidos clientes', value: stats.partidos, icon:'🏛️', color:'#E1F5EE', tc:'#085041' },
    { label:'Usuários totais', value: stats.usuarios, icon:'👥', color:'#E6F1FB', tc:'#185FA5' },
  ];

  return (
    <Layout title="Dashboard">
      <div style={styles.grid}>
        {cards.map(c => (
          <div key={c.label} style={{...styles.card, background:c.color}}>
            <div style={styles.icon}>{c.icon}</div>
            <div style={{...styles.value, color:c.tc}}>{c.value}</div>
            <div style={{...styles.label, color:c.tc}}>{c.label}</div>
          </div>
        ))}
      </div>
      <div style={styles.info}>
        <h3 style={styles.infoTitle}>Painel de Controle — Assistente de Contas Eleitorais®</h3>
        <p style={styles.infoText}>Gerencie administradores, partidos clientes e usuários. Use o menu lateral para navegar.</p>
      </div>
    </Layout>
  );
}

const styles = {
  grid: { display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:16, marginBottom:24 },
  card: { borderRadius:12, padding:'24px 20px', textAlign:'center' },
  icon: { fontSize:32, marginBottom:8 },
  value: { fontSize:36, fontWeight:700, margin:'0 0 4px' },
  label: { fontSize:13, fontWeight:500 },
  info: { background:'#f8f9fa', borderRadius:12, padding:'20px 24px' },
  infoTitle: { fontSize:16, fontWeight:600, color:'#1a1a2e', margin:'0 0 8px' },
  infoText: { fontSize:14, color:'#666', margin:0 },
};
